import React, { Component } from "react";
import { connect } from "react-redux";
import "./intro.scss";

class Intro extends Component {
  state = {
    liveData: []
  };
  accumulationHandler = event => {
    const { navToNextPage, setSeletedPlan } = this.props;
    event.preventDefault();
    setSeletedPlan("accumulation");
    navToNextPage();
  };
  decumulationHandler = event => {
    const { navToNextPage, setSeletedPlan } = this.props;
    event.preventDefault();

    navToNextPage();

    setSeletedPlan("decumulation");
  };

  componentDidMount() {
    const { setSeletedPlan, resetRitireData, resetAccumulation } = this.props;
    setSeletedPlan();

    // reset retire
    resetRitireData();
    // reset accumulation
    resetAccumulation();
  }

  render() {
    return (
      <div className="RIGcontainer">
        <div className="RIGheading">
          <div>
            70% of people in America will outlive their <span>Nest Egg</span>
          </div>
          <div style={{ fontSize: "0.75em", paddingTop: "10px" }}>
            Are you prepared for the<br></br>
            <span>Retirement Income Gap (RIG)?</span>
          </div>
        </div>
        <div className="RIGButton-container">
          <div className="RIGButton" onClick={this.decumulationHandler}>
            PREPARE <br></br>
            <span>DECUMULATION PLAN >></span>
            {/* withdraw plan */}
          </div>
          <div className="RIGButton" onClick={this.accumulationHandler}>
            PREPARE <br></br>
            <span>ACCUMULATION PLAN >></span>
            {/* retirement plan */}
          </div>
        </div>
      </div>
    );
  }
}
export default connect(null, dispatch => ({
  resetRitireData: () => dispatch({ type: "RETIREMENT_RESET" }),
  resetAccumulation: () => dispatch({ type: "ACCUMULATION_RESET" }),
  setSeletedPlan: value =>
    dispatch({ type: "RETIREMENT_SET_PLAN", payload: value })
}))(Intro);

// RETIREMENT_RESET



// WEBPACK FOOTER //
// ./src/components/pages/Retire/Intro.jsx